/**
 * Drop-in for `jwt-decode`'s `jwtDecode`.
 * Decodes the JWT payload only (no signature verification).
 */
export function jwtDecode(token, options = {}) {
  if (typeof token !== 'string') {
    throw new Error('Invalid token specified: must be a string')
  }

  const parts = token.split('.')
  if (parts.length < 2) {
    throw new Error('Invalid token specified: missing payload')
  }

  const partIndex = options.header ? 0 : 1
  const segment = parts[partIndex]
  if (!segment) {
    throw new Error('Invalid token specified: missing segment')
  }

  try {
    const json = base64UrlDecode(segment)
    return JSON.parse(json)
  } catch (error) {
    throw new Error(
      `Invalid token specified: ${error instanceof Error ? error.message : error}`,
    )
  }
}

function base64UrlDecode(segment) {
  const normalized = segment.replace(/-/g, '+').replace(/_/g, '/')
  const pad = normalized.length % 4
  const padded =
    pad === 0 ? normalized : normalized + '='.repeat(4 - pad)

  if (typeof atob === 'function') {
    // Decode UTF-8 safely
    const binary = atob(padded)
    const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0))
    if (typeof TextDecoder === 'function') {
      return new TextDecoder().decode(bytes)
    }
    return binary
  }

  // Node / test fallback
  return Buffer.from(padded, 'base64').toString('utf8')
}

export default jwtDecode
